import { DefaultState } from 'store/reducers/types';

export const READ_CLIENT_STORES_DATA_REQUEST = "READ_CLIENT_STORES_DATA_REQUEST";
export const READ_CLIENT_STORES_DATA_SUCCESS = "READ_CLIENT_STORES_DATA_SUCCESS";
export const READ_CLIENT_STORES_DATA_FAILURE = "READ_CLIENT_STORES_DATA_FAILURE";

export interface ClientStoresRow {
  filledPercent: string;
  id: number;
  lastJobComment: string;
  leftCand: number;
  leftSlots: number;
  name: string;
  neededCand: number;
  neededFromExternal: string;
  neededSlots: number;
  newSignups: string;
  notCalled: string;
  weight: number;
};

export interface ClientStoresData {
  rows: ClientStoresRow[] | [];
  totalCount: number;
};

export type ClientStoresState = DefaultState & {
  contents?: ClientStoresData;
};

interface ReadClientStoresDataRequest {
  type: typeof READ_CLIENT_STORES_DATA_REQUEST;
};

interface ReadClientStoresDataSuccess {
  type: typeof READ_CLIENT_STORES_DATA_SUCCESS;
  contents: ClientStoresData;
}

interface ReadClientStoresDataFailure {
  type: typeof READ_CLIENT_STORES_DATA_FAILURE;
}

export type ReadClientStoresActionTypes = ReadClientStoresDataRequest | ReadClientStoresDataSuccess | ReadClientStoresDataFailure;